module.exports = __webpack_public_path__ + "static/media/i3-cured.e49b3971.png";